const state = {
  holidayset_list: []
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/holidayset/holidayset.state.js
// module id = null
// module chunks = 